import type Item from 'owa-service/lib/contract/Item';

export interface USQStore {
    // ESQ storage for the account
    emailStorage: StorageData;

    // MSQ storage for the account
    microsoftStorage: StorageData;

    // List of selected items from manageMail view
    selectedItems: Item[];
}

export interface StorageData {
    // Bytes of total storage available
    totalSpace: number;

    // Bytes of storage used
    usedSpace: number;

    // Storage state for ESQ and MSQ
    state: ClientStorageState;

    // Fetch status
    storageDetailsFetchStatus: StorageDetailsFetchStatus;

    // Enforcement state
    enforcementState?: string;

    // block Action state
    blockAction?: BlockAction;

    // Grace period end date
    dateToFullyBlocked?: string | null;

    // List of services and space they occupy
    services?: ServiceStorageData[];
}

export interface ServiceStorageData {
    displayName: string;
    id: string;
    used: number;
}
export type ClientStorageState = any;

export enum StorageDetailsFetchStatus {
    NONE,
    SUCCESS,
    FAILURE,
}
export type BlockAction = any;
